import { render, staticRenderFns } from "./GbproRichText.vue?vue&type=template&id=34005ed2"
import script from "./GbproRichText.vue?vue&type=script&lang=js"
export * from "./GbproRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports